'use client';

import { c as _c } from "react/compiler-runtime";
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider as ThemeVarsProvider } from '@mui/material/styles';
import { useTranslate } from 'src/locales';
import { useSettingsContext } from 'src/components/settings';
import { createTheme } from './create-theme';
import { Rtl } from './with-settings/right-to-left';

// ----------------------------------------------------------------------

export function ThemeProvider(t0) {
  const $ = _c(16);
  let children;
  let other;
  let themeOverrides;
  if ($[0] !== t0) {
    ({
      themeOverrides,
      children,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = other;
    $[3] = themeOverrides;
  } else {
    children = $[1];
    other = $[2];
    themeOverrides = $[3];
  }
  const {
    currentLang
  } = useTranslate();
  const settings = useSettingsContext();
  const t1 = currentLang?.systemValue;
  let t2;
  if ($[4] !== settings.state || $[5] !== t1 || $[6] !== themeOverrides) {
    t2 = createTheme({
      settingsState: settings.state,
      localeComponents: t1,
      themeOverrides
    });
    $[4] = settings.state;
    $[5] = t1;
    $[6] = themeOverrides;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const theme = t2;
  let t3;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <CssBaseline />;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== children || $[10] !== settings.state.direction) {
    t4 = <Rtl direction={settings.state.direction}>{children}</Rtl>;
    $[9] = children;
    $[10] = settings.state.direction;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== other || $[13] !== t4 || $[14] !== theme) {
    t5 = <ThemeVarsProvider disableTransitionOnChange={true} theme={theme} {...other}>{t3}{t4}</ThemeVarsProvider>;
    $[12] = other;
    $[13] = t4;
    $[14] = theme;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  return t5;
}